export const config = {
  apiKey: "AIzaSyA9vl-DV4W0qUz3eyEKbhDMzoTcU1twGuM",
  authDomain: "kap-project-nsh-2504.firebaseapp.com",
  databaseURL: "https://kap-project-nsh-2504.firebaseio.com",
  projectId: "kap-project-nsh-2504",
  storageBucket: "kap-project-nsh-2504.appspot.com",
  messagingSenderId: "538060799891"
};



// WEBPACK FOOTER //
// ../shared-components/src/secrets.user.js